import { render, staticRenderFns } from "./setup-bsj-params-sms-modal.vue?vue&type=template&id=8ce85be2"
import script from "./setup-bsj-params-sms-modal.vue?vue&type=script&lang=js"
export * from "./setup-bsj-params-sms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports